import { img } from "./helpers";

const surfingHighlights = [
  {
    key: "surfing",
    icon: "surfing",
    label: {
      JP: "サーフィン体験",
      EN: "Surfing Experience",
      中文: "冲浪体验",
      한국어: "서핑 체험",
    },
  },
  {
    key: "drone",
    icon: "drone",
    label: {
      JP: "ドローン撮影",
      EN: "Drone Shooting",
      中文: "无人机拍摄",
      한국어: "드론 촬영",
    },
  },
  {
    key: "emptyHand",
    icon: "emptyHand",
    label: {
      JP: "手ぶらOK",
      EN: "No Gear Needed",
      中文: "无需装备",
      한국어: "빈손 OK",
    },
  },
  {
    key: "multilingual",
    icon: "multilingual",
    label: {
      JP: "多言語対応",
      EN: "Multilingual Support",
      中文: "多语言服务",
      한국어: "다국어 대응",
    },
  },
];

export const surfingTour = {
  id: "surfing",
  slug: "surfing",
  href: "/tours/surfing",
  categoryKey: "general",
  images: [img("v1783932710/GP010138_penbxd.webp")],
  tags: ["drone", "emptyHand", "surfing"],
  time: "3h",
  salePrice: {
    amount: 15000,
    unit: "person",
  },
  texts: {
    JP: {
      title: "宮古島サーフィン体験",
      startTimes: ["7:00頃"],
      people: "何名でも",
      notes:
        "手ぶらOK。ドローン撮影は1グループ+¥10,000、4名以上は+¥16,000です。",
    },
    EN: {
      title: "Miyakojima Surfing Experience",
      startTimes: ["Around 7:00"],
      people: "Any group size",
      notes:
        "No gear needed. Drone shooting is +¥10,000 / group, or +¥16,000 for groups of 4 or more. Please meet on site.",
    },
    中文: {
      title: "宫古岛冲浪体验",
      startTimes: ["约7:00"],
      people: "人数不限",
      notes:
        "无需自备装备。无人机拍摄为+¥10,000 / 每组，4人以上为+¥16,000。请现场集合。",
    },
    한국어: {
      title: "미야코지마 서핑 체험",
      startTimes: ["7:00경"],
      people: "인원 제한 없음",
      notes:
        "빈손으로 참가 OK. 드론 촬영은 그룹당 +¥10,000, 4명 이상은 +¥16,000입니다. 현장 집합입니다.",
    },
  },
  detail: {
    heroImage: img("v1784350164/DJI_20260708172917_0004_D_n0pzoh.webp"),
    heroYoutubeUrl: "https://www.youtube.com/watch?v=PbeyNc1Q9ec",
    isVertical: false,
    showCustomize: false,
    showGear: false,
    guideInstagram: {
      url: "https://www.instagram.com/swell_miyako_island/",
      handle: "@swell_miyako_island",
    },
    images: [
      img("v1784468640/DJI_20260719073835_0076_D_cx0wos.webp"),
      img(
        "v1784354836/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-18_15.06.59_noluwe.png",
      ),
      img("v1784350646/DJI_20260706065434_0044_D_kd2pm5.webp"),
      img("v1784350658/DJI_20260706094707_0054_D_t0d3pv.webp"),
      img("v1784350164/DJI_20260708172917_0004_D_n0pzoh.webp"),
      img("v1785121770/IMG_5983_abqsgh.webp"),
      img("v1785121767/IMG_5991_lvh285.webp"),
      img("v1785121763/IMG_5979_zjma3g.webp"),
      img("v1785121759/IMG_5975_oupbsb.webp"),
      img("v1785121754/IMG_5973_g1mbb7.webp"),
      img("v1785121750/IMG_5957_eclbjq.webp"),
      img("v1785121747/IMG_5945_ycqcjo.webp"),
      img("v1785121745/IMG_5943_ouoeo6.webp"),
    ],
  },
  detailTexts: {
    JP: {
      title: "Surfing Experience",
      pathTitle: "サーフィン体験",
      heroTitle: "宮古島サーフィン体験",
      heroDescription:
        "朝の宮古島で楽しむ、手ぶらOKのサーフィン体験。ドローン撮影はオプションで追加できます。",
      time: "3時間",
      startTimes: ["7:00頃"],
      people: "何名でも",
      heroPrice: "¥15,000",
      heroPriceNote: "税込 / 1名・撮影 +¥10,000〜",
      guideInstagramTitle: "ガイドのInstagram",
      guideInstagramText:
        "当日の海の雰囲気やサーフィンの様子はこちらから確認できます。",
      guideInstagramCta: "Instagramを見る",
      description:
        "宮古島でサーフィンができるのを知っていますか？初心者でも参加しやすいサーフィン体験です。通常料金は1人¥15,000。ドローン撮影は1グループ+¥10,000、4名以上の場合は+¥16,000で、レッスン後に写真・映像データをお渡しします。集合は現地集合となります。",
      featureIntro:
        "宮古島の美しい海でサーフィンしませんか？宮古島でサーフィンができることはまだあまり知られていませんが、人が少なく波もあり、サーフィンをするために宮古島へ来る方も多いです。ただし、ポイントやリーフなど危険も多いため、ローカル出身のガイドがその日の海況に合わせて安全に楽しめるポイントへご案内します。",
      highlights: surfingHighlights,
      detailItems: [
        ["催行日", "毎日相談可能"],
        ["開始時間", "7:00頃"],
        ["所要時間", "約3時間"],
        ["料金", "¥15,000(税込) / 1名"],
        [
          "撮影オプション",
          "ドローン撮影 +¥10,000 / 1グループ、4名以上 +¥16,000",
        ],
        ["人数", "何名でも相談可能"],
        ["対応言語", "日本語 / English / 中文 / 한국어"],
      ],
      included: [
        "レッスン代",
        "サーフィンレッスン",
        "サーフボードレンタル",
        "リーフブーツレンタル",
        "多言語対応",
      ],
      notIncluded: ["ドローン撮影(+¥10,000 / 1グループ、4名以上 +¥16,000)"],
      price: {
        title: "Price",
        subtitle: "料金",
        list: [
          {
            priceTitle: "サーフィン体験",
            price: "¥15,000 / 1名",
            priceDescription:
              "レッスン代、サーフボードレンタル、リーフブーツレンタル込み。ドローン撮影は+¥10,000 / 1グループ、4名以上は+¥16,000です。集合は現地集合となります。",
          },
        ],
      },
      faqs: [
        {
          question: "写真や動画はもらえますか？",
          answer:
            "撮影オプションありの場合、レッスン終了後AirDropにてお渡しします。",
        },
        {
          question: "送迎はありますか？",
          answer: "送迎はありません。集合場所は事前にご連絡いたします。",
        },
        {
          question: "年齢制限はありますか？",
          answer:
            "ありません。小さなお子様でもローカルガイドが安心、安全にレクチャーします。",
        },
        {
          question: "支払いはいつですか？",
          answer: "当日現金でお支払いをお願いいたします。",
        },
      ],
      scheduleItems: [
        {
          time: "07:00",
          title: "現地集合",
          text: "集合場所は事前にご連絡いたします。その日のベストスポットで開催します。",
          image: img("v1785121747/IMG_5945_ycqcjo.webp"),
        },
        {
          time: "07:30",
          title: "サーフィンレッスン",
          text: "安全説明と基本レッスンのあと、海でサーフィンを楽しみます。",
          image: img(
            "v1784354836/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-18_15.06.59_noluwe.png",
          ),
        },
        {
          time: "09:30",
          title: "写真・映像データのお渡し",
          text: "ドローンで撮影した写真・映像をお渡しします。",
          image: img("v1785121745/IMG_5943_ouoeo6.webp"),
        },
        {
          time: "10:00",
          title: "解散",
          text: "",
          image: img("v1785121767/IMG_5991_lvh285.webp"),
        },
      ],
    },
    EN: {
      title: "Surfing Experience",
      pathTitle: "Surfing",
      heroTitle: "Miyakojima Surfing Experience",
      heroDescription:
        "A morning surfing experience in Miyakojima. No gear needed. Drone shooting can be added as an option.",
      time: "3 hours",
      startTimes: ["Around 7:00"],
      people: "Any group size",
      heroPrice: "¥15,000",
      heroPriceNote: "tax included / person, drone shooting +¥10,000〜",
      guideInstagramTitle: "Guide Instagram",
      guideInstagramText:
        "Check the local ocean conditions and surfing vibe from the guide account.",
      guideInstagramCta: "View Instagram",
      description:
        "Did you know you can surf in Miyakojima? This is a beginner-friendly surfing experience. The standard price is ¥15,000 per person. Drone shooting can be added for +¥10,000 / group, or +¥16,000 for groups of 4 or more, and photo/video data will be delivered after the lesson. Please meet on site.",
      featureIntro:
        "Why not surf in Miyakojima’s beautiful ocean? Surfing in Miyakojima is still not widely known, but the waves, quiet spots, and clear water bring many surfers here. Some points and reef areas can be dangerous, so enjoying it with a local guide is recommended.",
      highlights: surfingHighlights,
      detailItems: [
        ["Available days", "Flexible"],
        ["Start time", "Around 7:00"],
        ["Duration", "About 3 hours"],
        ["Price", "¥15,000 tax included / person"],
        [
          "Shooting option",
          "Drone shooting +¥10,000 / group, or +¥16,000 for groups of 4 or more",
        ],
        ["Guests", "Any group size"],
        ["Languages", "Japanese / English / Chinese / Korean"],
      ],
      included: [
        "Lesson fee",
        "Surfing lesson",
        "Surfboard rental",
        "Reef boots rental",
        "Multilingual support",
      ],
      notIncluded: [
        "Drone shooting(+¥10,000 / group, or +¥16,000 for groups of 4 or more)",
        "Meals",
        "Personal expenses",
      ],
      price: {
        title: "Price",
        subtitle: "Price",
        list: [
          {
            priceTitle: "Surfing Experience",
            price: "¥15,000 / person",
            priceDescription:
              "Includes lesson fee, surfboard rental, and reef boots rental. Drone shooting is +¥10,000 / group, or +¥16,000 for groups of 4 or more. Please meet on site.",
          },
        ],
      },
      faqs: [
        {
          question: "Can I receive photos and videos?",
          answer:
            "If you add the shooting option, we will send them via AirDrop after the lesson.",
        },
        {
          question: "Is pickup/drop-off available?",
          answer:
            "No. Please meet on site. We will share the meeting place in advance.",
        },
        {
          question: "Is there an age limit?",
          answer: "No, there is no age limit.",
        },
        {
          question: "When do I pay?",
          answer: "Please pay on the day of the tour.",
        },
      ],
      scheduleItems: [
        {
          time: "07:00",
          title: "Meeting on site",
          text: "We will share the meeting place in advance and meet at the best point for the day.",
          image: img("v1785121747/IMG_5945_ycqcjo.webp"),
        },
        {
          time: "07:30",
          title: "Surfing Lesson",
          text: "After safety guidance and a basic lesson, enjoy surfing in the ocean.",
          image: img("v1782541275/06_euvqzf.jpg"),
        },
        {
          time: "09:30",
          title: "Photo and Video Delivery",
          text: "Receive photos and videos captured by drone.",
          image: img("v1785121745/IMG_5943_ouoeo6.webp"),
        },
        {
          time: "10:00",
          title: "Finish",
          text: "The tour ends on site after handing over the photo and video data.",
          image: img("v1785121767/IMG_5991_lvh285.webp"),
        },
      ],
    },
    中文: {
      title: "Surfing Experience",
      pathTitle: "冲浪体验",
      heroTitle: "宫古岛冲浪体验",
      heroDescription:
        "清晨在宫古岛体验冲浪，无需自备装备。无人机拍摄可作为选项追加。",
      time: "3小时",
      startTimes: ["约7:00"],
      people: "人数不限",
      heroPrice: "¥15,000",
      heroPriceNote: "含税 / 每人，无人机拍摄+¥10,000〜",
      guideInstagramTitle: "向导 Instagram",
      guideInstagramText: "可在向导账号查看当天海况和冲浪体验氛围。",
      guideInstagramCta: "查看 Instagram",
      description:
        "你知道宫古岛也可以冲浪吗？这是适合初学者参加的宫古岛冲浪体验。通常价格为每人¥15,000。无人机拍摄为每组+¥10,000，4人以上为+¥16,000，课程结束后提供照片・视频数据。请现场集合。",
      featureIntro:
        "想在宫古岛美丽的大海中冲浪吗？很多人还不知道宫古岛也可以冲浪，但这里人少、有浪，也有不少人为了冲浪来到宫古岛。不过冲浪点和珊瑚礁区域存在危险，建议在当地向导陪同下体验。",
      highlights: surfingHighlights,
      detailItems: [
        ["出行日", "可咨询"],
        ["开始时间", "约7:00"],
        ["所需时间", "约3小时"],
        ["费用", "¥15,000(含税) / 每人"],
        ["拍摄选项", "无人机拍摄 +¥10,000 / 每组，4人以上 +¥16,000"],
        ["人数", "人数不限，可咨询"],
        ["对应语言", "日语 / 英语 / 中文 / 韩语"],
      ],
      included: [
        "教学费用",
        "冲浪教学",
        "冲浪板租赁",
        "礁石鞋租赁",
        "多语言服务",
      ],
      notIncluded: [
        "无人机拍摄(+¥10,000 / 每组，4人以上 +¥16,000)",
        "餐费",
        "个人消费",
      ],
      price: {
        title: "Price",
        subtitle: "费用",
        list: [
          {
            priceTitle: "冲浪体验",
            price: "¥15,000 / 每人",
            priceDescription:
              "包含教学费用、冲浪板租赁和礁石鞋租赁。无人机拍摄+¥10,000 / 每组，4人以上+¥16,000。请现场集合。",
          },
        ],
      },
      faqs: [
        {
          question: "可以收到照片和视频吗？",
          answer: "如追加拍摄选项，课程结束后会通过 AirDrop 发送。",
        },
        {
          question: "有接送服务吗？",
          answer: "没有接送服务。集合地点会提前告知。",
        },
        {
          question: "有年龄限制吗？",
          answer: "没有。",
        },
        {
          question: "什么时候付款？",
          answer: "请在当天付款。",
        },
      ],
      scheduleItems: [
        {
          time: "07:00",
          title: "现场集合",
          text: "集合地点会提前告知，并在当天最适合的地点进行。",
          image: img("v1785121747/IMG_5945_ycqcjo.webp"),
        },
        {
          time: "07:30",
          title: "冲浪教学",
          text: "进行安全说明和基础教学后，在海中体验冲浪。",
          image: img("v1782541275/06_euvqzf.jpg"),
        },
        {
          time: "09:30",
          title: "交付照片・视频",
          text: "提供无人机拍摄的照片・视频数据。",
          image: img("v1785121745/IMG_5943_ouoeo6.webp"),
        },
        {
          time: "10:00",
          title: "解散",
          text: "交付照片・视频数据后，在现场解散。",
          image: img("v1785121767/IMG_5991_lvh285.webp"),
        },
      ],
    },
    한국어: {
      title: "Surfing Experience",
      pathTitle: "서핑 체험",
      heroTitle: "미야코지마 서핑 체험",
      heroDescription:
        "아침 미야코지마에서 즐기는 빈손 OK 서핑 체험. 드론 촬영은 옵션으로 추가할 수 있습니다.",
      time: "3시간",
      startTimes: ["7:00경"],
      people: "인원 제한 없음",
      heroPrice: "¥15,000",
      heroPriceNote: "세금 포함 / 1인, 드론 촬영 +¥10,000〜",
      guideInstagramTitle: "가이드 Instagram",
      guideInstagramText:
        "당일 바다 분위기와 서핑 체험 모습을 가이드 계정에서 확인할 수 있습니다.",
      guideInstagramCta: "Instagram 보기",
      description:
        "미야코지마에서 서핑을 할 수 있다는 것을 알고 계신가요? 초보자도 참가하기 쉬운 미야코지마 서핑 체험입니다. 기본 요금은 1인 ¥15,000입니다. 드론 촬영은 그룹당 +¥10,000, 4명 이상은 +¥16,000에 추가할 수 있으며, 레슨 후 사진・영상 데이터를 전달합니다. 현장 집합입니다.",
      featureIntro:
        "미야코지마의 아름다운 바다에서 서핑해 보지 않으실래요? 미야코지마에서 서핑을 할 수 있다는 것은 아직 많이 알려져 있지 않지만, 사람이 적고 파도도 있어 서핑을 위해 미야코지마를 찾는 분들도 많습니다. 다만 포인트와 리프 등 위험한 곳도 많아 가이드와 함께 즐기는 것을 추천합니다.",
      highlights: surfingHighlights,
      detailItems: [
        ["진행일", "상담 가능"],
        ["시작 시간", "7:00경"],
        ["소요 시간", "약 3시간"],
        ["요금", "¥15,000(세금 포함) / 1인"],
        ["촬영 옵션", "드론 촬영 +¥10,000 / 그룹, 4명 이상 +¥16,000"],
        ["인원", "인원 제한 없음, 상담 가능"],
        ["대응 언어", "일본어 / 영어 / 중국어 / 한국어"],
      ],
      included: [
        "레슨비",
        "서핑 레슨",
        "서프보드 렌탈",
        "리프 부츠 렌탈",
        "다국어 대응",
      ],
      notIncluded: [
        "드론 촬영(+¥10,000 / 그룹, 4명 이상 +¥16,000)",
        "식비",
        "개인 비용",
      ],
      price: {
        title: "Price",
        subtitle: "요금",
        list: [
          {
            priceTitle: "서핑 체험",
            price: "¥15,000 / 1인",
            priceDescription:
              "레슨비, 서프보드 렌탈, 리프 부츠 렌탈 포함. 드론 촬영은 그룹당 +¥10,000, 4명 이상은 +¥16,000입니다. 현장 집합입니다.",
          },
        ],
      },
      faqs: [
        {
          question: "사진이나 영상을 받을 수 있나요?",
          answer:
            "촬영 옵션을 추가한 경우, 레슨 종료 후 AirDrop으로 전달합니다.",
        },
        {
          question: "송영이 있나요?",
          answer: "송영은 없습니다. 집합 장소는 사전에 안내드립니다.",
        },
        {
          question: "연령 제한이 있나요?",
          answer: "없습니다.",
        },
        {
          question: "결제는 언제 하나요?",
          answer: "당일 부탁드립니다.",
        },
      ],
      scheduleItems: [
        {
          time: "07:00",
          title: "현장 집합",
          text: "집합 장소는 사전에 안내드리며, 당일 가장 좋은 포인트에서 진행합니다.",
          image: img("v1785121747/IMG_5945_ycqcjo.webp"),
        },
        {
          time: "07:30",
          title: "서핑 레슨",
          text: "안전 설명과 기본 레슨 후 바다에서 서핑을 즐깁니다.",
          image: img("v1782541275/06_euvqzf.jpg"),
        },
        {
          time: "09:30",
          title: "사진・영상 전달",
          text: "드론으로 촬영한 사진・영상 데이터를 전달합니다.",
          image: img("v1785121745/IMG_5943_ouoeo6.webp"),
        },
        {
          time: "10:00",
          title: "해산",
          text: "사진・영상 데이터를 전달한 후 현장에서 해산합니다.",
          image: img("v1785121767/IMG_5991_lvh285.webp"),
        },
      ],
    },
  },
};
